var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-1"},[_c('div',{staticClass:"py-0 ma-0 col-12 fs-14 text-white",domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }